// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ps-create-new-button{
  background-color: var(--primary);
  color: white;
  border-radius: 5px;
  border: none;
  padding: 10px 20px;
  font-weight: bold;
}

.ps-title{
  font-size: 20px;
  font-weight: bold;
}

.ps-header{
  border-bottom: solid 1px #c2c2c2;
  padding-bottom: 20px;
}

.ps-header-textbox{
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.no-margin{
  margin: 0px;
  padding: 0px;
}

.ps-list-box{
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 20px 0;
}

.ps-list-item{
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background-color: var(--bg-card);
}

.playlits-list-item-name{
  font-weight: bold;
  width: 70%;
}

.ps-list-item-buttons{
  width: 30%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-end;
}

.ps-list-item-edit{
  background-color: var(--primary);
  color: white;
  border-radius: 5px;
  border: none;
  padding: 5px 10px;
  font-weight: bold;
}

.ps-list-item-delete{
  background-color: #ea8690;
  color: white;
  border-radius: 5px;
  border: solid 1px #f52b32;
  padding: 5px 10px;
  font-weight: bold;
}

.new_product{
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 20px 0;
}

.new_product_form{
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/playlists/playlists.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB","sourcesContent":[".ps-create-new-button{\n  background-color: var(--primary);\n  color: white;\n  border-radius: 5px;\n  border: none;\n  padding: 10px 20px;\n  font-weight: bold;\n}\n\n.ps-title{\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.ps-header{\n  border-bottom: solid 1px #c2c2c2;\n  padding-bottom: 20px;\n}\n\n.ps-header-textbox{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.no-margin{\n  margin: 0px;\n  padding: 0px;\n}\n\n.ps-list-box{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 20px 0;\n}\n\n.ps-list-item{\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  padding: 20px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background-color: var(--bg-card);\n}\n\n.playlits-list-item-name{\n  font-weight: bold;\n  width: 70%;\n}\n\n.ps-list-item-buttons{\n  width: 30%;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n.ps-list-item-edit{\n  background-color: var(--primary);\n  color: white;\n  border-radius: 5px;\n  border: none;\n  padding: 5px 10px;\n  font-weight: bold;\n}\n\n.ps-list-item-delete{\n  background-color: #ea8690;\n  color: white;\n  border-radius: 5px;\n  border: solid 1px #f52b32;\n  padding: 5px 10px;\n  font-weight: bold;\n}\n\n.new_product{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 20px 0;\n}\n\n.new_product_form{\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
